<form
  [formGroup]="addPackageTypeForm"
  (ngSubmit)="onAddPackageType()"
  #pTypeForm
>
  <div class="main-card">
    <div class="card-header">
      <a
        class="main-btn back-btn"
        *ngIf="!isFromAddPage"
        [routerLink]="['./../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <a
        class="main-btn back-btn"
        *ngIf="isFromAddPage"
        [routerLink]="[previousUrl]"
        [queryParams]="{ fromPage: '/partners' }"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button
        class="main-btn"
        type="submit"
        [ngClass]="{ disabled: !addPackageTypeForm.valid }"
        [disabled]="!addPackageTypeForm.valid"
      >
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <h3 class="card-title">Dodaj tip pakovanja</h3>
    <div class="card-body">
      <div class="grid">
        <div class="col-6">
          <section *ngFor="let pType of getControls(); let i = index">
            <div [formGroupName]="i" class="flex">
              <div class="field w-100 mr-3">
                <label> {{ i + 1 }}. Oznaka tipa</label>
                <section class="flex align-items-center w-100">
                  <input
                    type="text"
                    class="w-100"
                    formControlName="label"
                    pInputText
                  />
                </section>
              </div>

              <div class="field w-100">
                <label> Naziv tipa</label>
                <section class="flex align-items-center w-100">
                  <input
                    type="text"
                    class="w-100"
                    formControlName="name"
                    pInputText
                  />
                  <button
                    class="second-btn small-btn ml-3"
                    type="button"
                    pTooltip="Izbriši"
                    tooltipPosition="top"
                    (click)="removePackageType(i)"
                    *ngIf="!(addPackageTypeForm.length == 1)"
                  >
                    <i class="pi pi-trash"></i>
                  </button>
                </section>
              </div>
            </div>
          </section>
          <button
            class="second-btn mt-3"
            type="button"
            (click)="addPackageType()"
          >
            Dodaj tip
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
